import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import React from 'react'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <Canvas
        style={{ position: 'fixed', inset: 0 }}
        dpr={[1, 2]}
        camera={ {
            fov: 50,
            near: 0.1,
            far: 200,
            position: [ 0, 0.6, 7 ]
        } }
    >
        <Experience />
    </Canvas>
)